import React, { FormEvent, useEffect, useRef, useState } from "react";
import PaperCard from "../../../components/ui/PaperCard";
import {
  Divider,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Tooltip,
  LinearProgress,
  styled,
  Typography,
  Skeleton,
} from "@mui/material";
import { InputField, InputFieldOTP } from "../../../components/ui/Inputs";
import SelectOptions from "../../../components/ui/SelectOptions";
import {
  PrimaryButton,
  SecondaryButtonText,
  SecondaryButton,
} from "../../../components/ui/Button";
import { useForm } from "react-hook-form";
import filterIcon from "./../../../assets/images/icons/filter.png";
import Tables from "../../../components/ui/Tables";
import ModalPopup from "../../../components/ui/ModalPopup";
import BasicDatePicker from "../../../components/ui/BasicDatePicker";
import {
  Box,
  color,
  fontSize,
  fontWeight,
  useMediaQuery,
  useTheme,
} from "@mui/system";
import {
  formatIndianRupees,
  handlePercentAmount,
  checkPercentage,
} from "../../../utils/formatting";
import { RootState } from "../../../services/redux/store";
import service from "../../../services/api/service";
import { useDispatch, useSelector } from "react-redux";
import postsServices from "../../../services/api/service/postsService";
import Toast from "../../../components/ui/Toast";
import InfoIcon from "./../../../assets/images/icons/info.png";
import { ArrowForward, EditNotificationsRounded } from "@mui/icons-material";
import UtilizedIcon from "../../../assets/images/icons/utilized.png";
import AvailableIcon from "../../../assets/images/icons/available.png";
import {
  authSelector,
  userPermissionSelector,
} from "../../../services/redux/slices/authSlice";
import dayjs from "dayjs";
import { formatDate, parseAndFormatDate } from "../../../utils/dateFormatUtils";
import { filterOptionsDisbursement, messages } from "../../../data/constant";
import LoaderBackdrop from "../../../components/ui/LoaderBackdrop";
import { setStatusPopup } from "../../../services/redux/slices/statusPopupSlice";
import { setUnreadCount } from "../../../services/redux/slices/notificationSlice";
import notificationsServices from "../../../services/api/service/notificationService";
import AddIcon from "@mui/icons-material/Add";
import {
  cleardisbursementButtonSlice,
  setActionRowData,
  setdisbursementButtonValue,
  setLastDisbursementStatus,
} from "../../../services/redux/slices/disbursementButtonSlice";
import { clearDocumentFormType } from "../../../services/redux/slices/documentFormSlice";
import Card from "../../../components/ui/Card";

import { OutlinedSmallButton } from "../../../components/ui/Button";
import AccordionTransition from "../../../components/ui/Accordian";
import AccountSelectorDropDown from "../../../components/ui/AccountSelectorDropDown";
import CardItemList from "../../../components/ui/mobile/CardItemList";
import { setSelectedIndex } from "../../../services/redux/slices/tabsSlice";
import { useNavigate } from "react-router-dom";
import { decrypt } from "../../../utils/crypto";
import { trackEvent } from "../../../utils/ga";

interface LastDisbFormStatusData {
  description: string;
  firstName: string;
  lastDisbFormId: number;
  lastDisbStatus: string;
  lastDisbursementDate: string;
  lastName: string;
  loanUndisbursedAmount: number;
  nameOfTheUniversity: string;
  totalLoanDisbursed: number;
  totalSanctionedAmount: number;
  allowDisbursement: boolean;
}

interface Column {
  id: string;
  label: string;
  format?: (value: number) => string;
}

export interface RowData {
  [key: string]: string | number | null;
}
interface Option {
  value: string | number;
  label: string | number | React.ReactNode;
}
interface DashboardItemType {
  description: string;
  firstName: string;
  lastName: string;
  nameOfTheUniversity: string;
  lastDisbursementDate: string;
  totalSanctionedAmount: number;
  loanUndisbursedAmount: number;
  totalLoanDisbursed: number;
}
interface RetrievedData {
  cifNumber?: string | null;
}

const RequestForDisbursement = () => {
  const { register, handleSubmit, setValue, getValues, watch, reset } =
    useForm();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpenOtp, setIsModalOpenOtp] = useState(false);
  const [referenceNumber, setReferenceNumber] = useState("");
  const [overdueAmount, setOverdueAmount] = useState(0);
  const selectedOptionValue = watch("selectedOption");
  const [fromDate, setFromDate] = useState<Date | null>(null);
  const [toDate, setToDate] = useState<Date | null>(null);
  const [status, setStatus] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [selectedOptionFilterValue, setSelectedOptionFilterValue] = useState<
    string | number
  >("");
  const [dashboardData, setDashboardData] = useState<DashboardItemType>();
  const [availableLimit, setAvailableLimit] = useState<number | null>(null);
  const [otp, setOTP] = useState(["", "", "", "", "", ""]);
  const inputRefs = useRef<HTMLInputElement[]>(Array(6).fill(null));
  const { userProfile } = useSelector(authSelector);
  const [inputValue, setInputValue] = useState("");
  const [nagitiveValueCheck, setNagitiveValueCheck] = useState("");
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [errorMessageOtp, setErrorMessageOtp] = useState<string>("");
  const [disabledButton, setdisabledButton] = useState(false);
  const [IsLoadingRequest,setIsLoadingRequest]= useState(true);
  const { rolePermissions } = useSelector(userPermissionSelector);
  const dispatch = useDispatch();
  const [disbursementuserDetails, setDisbursementUserDetails] = useState<any[]>(
    []
  );
  const handleFilterButtonClick = () => {
    setIsModalOpen(true);
  };
  const clearData = () => {
    setIsModalOpen(false);
    setSelectedOptionFilterValue("");
    setFromDate(null);
    setToDate(null);
    fetchData(null,null,"");
  };
  const filterData = () => {
    fetchData(fromDate,toDate,selectedOptionFilterValue);
    setIsModalOpen(false);
    // setSelectedOptionFilterValue("");
    // setFromDate(null);
    // setToDate(null);
  };
  const handleCloseModal = () => {
    setIsModalOpen(false);
    // setSelectedOptionFilterValue("");
    // setFromDate(null);
    // setToDate(null);
  };
  const handleCloseModalOtp = () => {
    setIsModalOpenOtp(false);
    setdisabledButton(true);
    setOTP(["", "", "", "", "", ""]);
    setValue("amount", "");

    setMessage("");
  };

  // -------------------------------------New Code---------------------------------------
  const selectedLoanNumber = useSelector(
    (state: RootState) => state.dashboardData.selectedLoanNumber
  );
  useEffect(() => {
    setFromDate(null);
    setToDate(null);
    setSelectedOptionFilterValue("");
  }, [selectedLoanNumber]);
  const dashboardDataSet = useSelector(
    (state: RootState) => state.dashboardData.sanctionedDisbursedData
  );
  useEffect(() => {
    const matchedObject = dashboardDataSet.find(
      (data: any) => data.loanAccountNumber === selectedLoanNumber
    );
    setValue("amount", "");
    setErrorMessage("");
    dispatch(clearDocumentFormType());
  }, [selectedLoanNumber]);
  useEffect(() => {
    const matchedObject = dashboardDataSet.find(
      (data: any) => data.loanAccountNumber === selectedLoanNumber
    );
    setDashboardData(matchedObject);
    setValue("amount", "");
    setErrorMessage("");
    //    setValue("accountNo", dashboardData?.beneficiaryName[0]?.accountNo);
    // setValue("acHolderName", dashboardData?.beneficiaryName[0]?.acHolderName);
  }, [setValue, dashboardData]);

  // -------------------------------------New Code---------------------------------------

  const columns: Column[] = [
    {
      id: "requestedDate",
      label: "Request Date",
      format: (rowData: any) => formatDate(rowData.requestedDate),
    },

    {
      id: "referenceNumber",
      label: "Request ID",
      format: (rowData: any) => rowData.referenceNumber || "-",
    },
    {
      id: "crmTrackingId",
      label: "Tracking id",
      format: (rowData: any) => rowData.crmTrackingId || "-",
    },
    {
      id: "trancheAmount",
      label: "Requested Amount",
      format: (rowData: any) => rowData.trancheAmount || "-",
    },
    {
      id: "initatedBy",
      label: "Initiated by",
      format: (rowData: any) => rowData.initatedBy || "-",
    },
    // {
    //   id: "disbursemntDate",
    //   label: "Disbursement Date",
    //   format: (rowData: any) => rowData.disbursemntDate || "-",
    // },
    {
      id:"disbursedAmount",
      label:"Disbursement Amount",
      format: (rowData: any) =>  rowData.disbursedAmount ||"-",
    },
    {
      id: "status",
      label: "Status",
      format: (rowData: any) => rowData.status || "-",
    },
    {
      id: "initatedBy",
      label: "Action",
      format: (rowData: any) => (
        <IconButton onClick={() => handleActionClick(rowData)}>
          <EditNotificationsRounded />
        </IconButton>
      ),
    },
  ];
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [rows, setRows] = useState<RowData[]>([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [toastOpen, setToastOpen] = useState(false);
  const [severity, setSeverity] = useState<
    "error" | "warning" | "info" | "success"
  >("success");
  const [message, setMessage] = useState("");
  const [lastDisbFormStatus, setLastDisbFormStatus] = useState("");
  const [clearDataStatus, setClearDataStatus] = useState(false);
  const [lastDisbFormStatusData, setLastDisbFormStatusData] =
    useState<LastDisbFormStatusData | null>(null);
  const [isMultipleReqRes, setIsMultipleReqRes] = useState(false);
  const navigate = useNavigate();
  const initialFetch = useRef(true);

  const handleToastClose = () => {
    setToastOpen(false);
  };
  // -------------------------------------------------------------------------------------
  let spacing = 4;
  const theme = useTheme();
  const isXsOrSm = useMediaQuery(theme.breakpoints.down("sm"));
  if (isXsOrSm) {
    spacing = 0;
  }
  let withdrawData = useSelector((state: RootState) => state.option.loanData);
  useEffect(() => {
    if (withdrawData && withdrawData.length > 0) {
      setAvailableLimit(withdrawData[0].availableLimit);
    }
  }, [withdrawData]);
  const selectedOption = useSelector(
    (state: RootState) => state.option.selectedOption
  );
  const sanctionedDisbursedData = useSelector(
    (state: RootState) => state.dashboardData.sanctionedDisbursedData
  );
  // Fetch and filter dashboard data based on selectedOption
  useEffect(() => {
    const filteredDashboardData = sanctionedDisbursedData?.filter(
      (item: any) => {
        return item.loanAccountNumber === selectedOption;
      }
    );
    setOverdueAmount(
      filteredDashboardData.length > 0
        ? filteredDashboardData[0].overdueAmount
        : 0
    );

    return () => { };
  }, [sanctionedDisbursedData, selectedOption]);

  // Effect to update dashboard data and overdue amount based on selectedloanAccountNumber
  const selectedloanAccountNumber = useSelector(
    (state: RootState) => state.dashboardData.selectedLoanNumber
  );

  useEffect(() => {
    const filteredDashboardData = sanctionedDisbursedData?.filter(
      (item: any) => {
        return item.loanAccountNumber === selectedloanAccountNumber;
      }
    );
    setOverdueAmount(
      filteredDashboardData.length > 0
        ? filteredDashboardData[0].overdueAmount
        : 0
    );
  }, [selectedloanAccountNumber]);
  useEffect(() => {
    if (dashboardDataSet[0]?.isExistDisbursementAllowdLoan == false) {
      dispatch(setSelectedIndex(0));
      navigate("/dashboard");

      dispatch(
        setStatusPopup({
          status: "no access",
          // message: `Disbursement requests are not permitted for this loan.`,
          message:
            "Disbursement requests are currently unavailable for this loan",
        })
      );
    }
  }, [dashboardDataSet]);

  const handleToDateChange = (date: Date | null) => {
    if (date) {
      const toDateDayjs = dayjs(date);
      setToDate(toDateDayjs.toDate());
    } else {
      setToDate(null);
    }
  };
  const handleFromDateChange = (date: Date | null) => {
    if (date) {
      const toDateDayjs = dayjs(date);
      setFromDate(toDateDayjs.toDate());
    } else {
      setToDate(null);
    }
  };

  const fetchData = async (fromDate: Date | null,
    toDate: Date | null,
    selectedOptionFilterValue: string | number) => {
    setIsLoading(true);
    const formattedFromDate = fromDate
      ? dayjs(fromDate).format("YYYY-MM-DD")
      : "";
    const formattedToDate = toDate ? dayjs(toDate).format("YYYY-MM-DD") : "";
    const statusQuery =
      selectedOptionFilterValue === "all"
        ? ""
        : `status=${selectedOptionFilterValue}&`;

    const pageSkip = page + 1; // API might be 1-based indexing
    const pageSize = rowsPerPage;
    const queryString = `?lan=${selectedLoanNumber}&${statusQuery}fromDate=${formattedFromDate}&toDate=${formattedToDate}&page=${pageSkip}&pageSize=${pageSize}`;
    const payload = {
      lan: selectedLoanNumber?.trim(),
      status:
        selectedOptionFilterValue === "all" ? "" : selectedOptionFilterValue,
      fromDate: formattedFromDate,
      toDate: formattedToDate,
      page: pageSkip,
      pageSize: pageSize,
    };
    try {
      if (selectedLoanNumber != undefined) {
        setRows([]);
        setIsLoadingRequest(true);
        const response = await service.posts.getPosts(
          `api/v1/dashboard/disb-detail-request${queryString}`
        );
        setDisbursementUserDetails(response?.data?.data);
        setLastDisbFormStatus(response?.data?.data[0]);
        setLastDisbFormStatusData(response?.data?.data[0]);
        postsServices
          .addPost("api/v1/dashboard/disb-req-history", payload)
          .then((responseHistory) => {
            const disbursementRequestHistory =
              responseHistory?.data?.disbursementRequestHistory.map(
                (item: any) => ({
                  ...item,
                   referenceNumber: item.referenceNumber
                    ? item.referenceNumber.toString()
                    : "-",
                  crmTrackingId: item.crmTrackingId
                    ? item.crmTrackingId.toString()
                    : "-",
                  disbursemntDate: item.disbursemntDate
                    ? item.disbursemntDate
                    : "-",
                })
              );
            setRows(disbursementRequestHistory);

            setIsLoadingRequest(false);
            setTotalRecords(responseHistory?.data?.totalCount);
          })
          .catch((error) => {setIsLoadingRequest(false); });
      }
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    fetchData(null,null,"");
  }, [selectedLoanNumber]);
  useEffect(() => {
    // if (initialFetch.current) {
    //   initialFetch.current = false;
    // } else {
    //   fetchData();
    // }
    fetchData(fromDate,toDate,selectedOptionFilterValue);
  }, [page, rowsPerPage]);
  const handleChangePage = (_: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value));
    setPage(0);
    // Removed fetchData() to avoid double API call; useEffect will handle data fetching
  };
  // ===================================================================================
  const disbursementHistoryBtn = () => {
    dispatch(cleardisbursementButtonSlice());
    dispatch(setdisbursementButtonValue("disbursementHistoryBtn"));
  };
  const matchedObject = dashboardDataSet.find(
    (data: any) => data.lanNumber === selectedLoanNumber
  );
  const fetchMultipleReqData = async (selectedloanAccountNumber: string) => {
    try {
      setIsMultipleReqRes(true)
      const payload = {
        loanAccountNumber: selectedloanAccountNumber
      }
      const response = await postsServices.multipleFundReq("api/v1/disbursement-form/check-fund-request-allowance", payload);
      if(response && response?.status === 200) {
        return response?.data?.data?.isAllowed
      }
    } catch(err) {
      console.error("Error While getting filters data", err)
      return false;
    } finally {
        setIsMultipleReqRes(false)
    }
  }

  const createNewRequestBtn = async () => {
    const isMultipleFundNotAllowed = await fetchMultipleReqData(selectedloanAccountNumber)
    trackEvent('Dash_Disb_CreateNewRequest', decrypt(userProfile?.id), {
      label: 'Dash_Disb_CreateNewRequest',
      category: 'Dash_Disb_CreateNewRequest',
      action: 'Dash_Disb_CreateNewRequest',
    });
    localStorage.removeItem("aggApplicationNo");
    localStorage.removeItem("disbursementFormId");
    dispatch(cleardisbursementButtonSlice());
    dispatch(setLastDisbursementStatus(lastDisbFormStatus));
    dispatch(setActionRowData(""));
    if (!isMultipleFundNotAllowed) {
      dispatch(
        setStatusPopup({
          status: "error",
          // message: `One request is already raised, and its status is ${lastDisbFormStatusData?.lastDisbStatus}. You cannot raise a new request until the current request is approved or rejected. To continue with the open request, please click the action button below.`,
          message: `Work in progress! You have already raised a disbursement request, and our team is diligently working on it. You cannot raise a new request unless we finish working on the previous one. Please check the status of the earlier request in the 'View Disbursement Request' section.`,
          buttonStatus: false,
        })
      );
    } 
    // else if (lastDisbFormStatusData?.lastDisbStatus === "indraft") {
    //   dispatch(
    //     setStatusPopup({
    //       status: "info",
    //       // message: `One request is already raised, and its status is ${lastDisbFormStatusData?.lastDisbStatus}. You cannot raise a new request until the current request is approved or rejected. To continue with the open request, please click the action button below.`,
    //       message: "You already have an ongoing request saved as a draft in the “Disbursement Request History”. Please make the necessary changes to the draft and submit the request for tranche disbursement",
    //       buttonStatus: false,
    //     })
    //   );
    // }

    else if (
      (lastDisbFormStatusData?.loanUndisbursedAmount ?? 0) >=
      (lastDisbFormStatusData?.totalSanctionedAmount ?? 0)
    ) {
      dispatch(
        setStatusPopup({
          status: "error",
          message: `The entire sanctioned amount has already been disbursed.`,
          buttonStatus: false,
        })
      );
    } 
    // else if ((lastDisbFormStatusData?.loanUndisbursedAmount ?? 0) <= 0) {
    //   dispatch(
    //     setStatusPopup({
    //       status: "error",
    //       message: `Your undisbursed amount is Rs. 0.00, so you cannot create a new disbursement request.`,
    //       buttonStatus: false,
    //     })
    //   );
    // }
    else if (
      matchedObject?.isExistDisbursementAllowdLoan === false ||
      matchedObject?.status != "A"
    ) {
      dispatch(
        setStatusPopup({
          status: "no access",
          // message: `Disbursement requests are not permitted for this loan.`,
          message:
            "Disbursement requests are currently unavailable for this loan",
        })
      );
    } else {
      const newObj = JSON.parse(JSON.stringify(lastDisbFormStatus))
      newObj.lastDisbFormId = null;
      localStorage.removeItem("disbursementFormId")
      localStorage.removeItem("aggApplicationNo");

      dispatch(setLastDisbursementStatus(newObj));
      dispatch(setdisbursementButtonValue("createNewRequestBtn"));
    }
  };

  const handleActionClick = (rowData: RowData) => {
    trackEvent('Dash_Disb_View', decrypt(userProfile?.id), {
      label: 'Dash_Disb_View',
      category: 'Dash_Disb_View',
      action: 'Dash_Disb_View',
    });
    localStorage.removeItem("aggApplicationNo");
    localStorage.removeItem("activeFormStep");
    localStorage.removeItem("disbursementFormId");
    dispatch(cleardisbursementButtonSlice());
    dispatch(setdisbursementButtonValue("createNewRequestBtn"));
    dispatch(setLastDisbursementStatus(lastDisbFormStatus));
    dispatch(setActionRowData(rowData));
  };

  const MultiColorProgressBar = styled(LinearProgress)(({ theme }) => ({
    height: 10,
    borderRadius: 5,
    backgroundColor: "rgba(22, 135, 148, 1)", // Available background
    "& .MuiLinearProgress-bar": {
      backgroundColor: "rgba(254, 193, 13, 1)", // Utilized color
    },
  }));
  const MultiColorProgressBarMobile = styled(LinearProgress)(({ theme }) => ({
    height: 10,
    borderRadius: "5px",
    backgroundColor: "rgba(22, 135, 148, 1)", // Available background
    "& .MuiLinearProgress-bar": {
      backgroundColor: "rgba(254, 193, 13, 1)", // Utilized color
    },
  }));
  return (
    <Grid sx={{ paddingTop: "20px" }} className="disbursement-page">
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <Card borderColor={true}>
            <Box>
              {isLoading ? (
                <>
                  {!isXsOrSm && (
                    <React.Fragment>
                      {/* Header Section */}
                      <Grid container sm sx={{ marginBottom: 2 }}>
                        <Grid item sm={8} sx={{ height: "28px" }}>
                          <Skeleton
                            variant="text"
                            width="80%"
                            sx={{ fontSize: "15px", height: "30px" }}
                          />
                          <Skeleton
                            variant="text"
                            width="60%"
                            sx={{
                              fontSize: "14px",
                              height: "24px",
                              marginTop: 1,
                            }}
                          />
                        </Grid>
                        <Grid
                          item
                          sm={4}
                          sx={{
                            display: "flex",
                            justifyContent: "right",
                            alignItems: "right",
                          }}
                        >
                          <Skeleton
                            variant="rectangular"
                            width="150px"
                            height="40px"
                            sx={{ borderRadius: "8px" }}
                          />
                        </Grid>
                      </Grid>
                      {/* Divider */}
                      <Grid container sm sx={{ paddingTop: "20px" }}>
                        <Grid item sm={12}>
                          <Divider
                            sx={{
                              border: isXsOrSm
                                ? ""
                                : "1px solid rgba(219, 218, 222, 1)",
                              borderColor: isXsOrSm
                                ? "rgba(0, 0, 0, 0.12)"
                                : "",
                              borderBottomWidth: isXsOrSm ? "thin" : "",
                              width: "100%",
                            }}
                          />
                        </Grid>
                      </Grid>
                      {/* Details Section */}
                      <Grid container sm sx={{ paddingTop: "30px" }}>
                        <Grid item sm={7}>
                          <Grid container spacing={8}>
                            {Array.from({ length: 3 }).map((_, i) => (
                              <Grid item sm={4} key={i}>
                                <Skeleton
                                  variant="text"
                                  width="80%"
                                  sx={{
                                    fontSize: "clamp(12px, 1.4vw, 14px)",
                                    height: "20px",
                                  }}
                                />
                                <Skeleton
                                  variant="text"
                                  width="70%"
                                  sx={{
                                    fontSize: "clamp(8px, 1vw, 12px)",
                                    height: "14px",
                                    marginTop: 2,
                                  }}
                                />
                              </Grid>
                            ))}
                          </Grid>
                          <Grid
                            container
                            spacing={8}
                            sx={{ paddingTop: "20px" }}
                          >
                            {Array.from({ length: 3 }).map((_, i) => (
                              <Grid item sm={4} key={i}>
                                <Skeleton
                                  variant="text"
                                  width="80%"
                                  sx={{
                                    fontSize: "clamp(8px, 1vw, 12px)",
                                    height: "20px",
                                  }}
                                />
                                <Skeleton
                                  variant="text"
                                  width="70%"
                                  sx={{
                                    fontSize: "clamp(8px, 1vw, 12px)",
                                    height: "14px",
                                    marginTop: 2,
                                  }}
                                />
                              </Grid>
                            ))}
                          </Grid>
                        </Grid>
                        <Grid item sm={1}>
                          <Box
                            sx={{
                              height: "100%",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <Skeleton
                              variant="rectangular"
                              width="2px"
                              height="100%"
                              sx={{ bgcolor: "rgba(219, 218, 222, 1)" }}
                            />
                          </Box>
                        </Grid>
                        <Grid item sm={4}>
                          <Grid container sm>
                            <Grid item sm={6}>
                              <Skeleton
                                variant="text"
                                width="80%"
                                sx={{
                                  fontSize: "clamp(11px, 1.2vw, 13px)",
                                  height: "22px",
                                }}
                              />
                              <Skeleton
                                variant="text"
                                width="50%"
                                sx={{
                                  fontSize: "clamp(14px, 1.2vw, 16px)",
                                  height: "24px",
                                  marginTop: 1,
                                }}
                              />
                              <Skeleton
                                variant="text"
                                width="40%"
                                sx={{
                                  fontSize: "clamp(11px, 1.2vw, 13px)",
                                  height: "20px",
                                  marginTop: 1,
                                }}
                              />
                            </Grid>
                            <Grid item sm={1}>
                              <Skeleton
                                variant="rectangular"
                                width="2px"
                                height="60px"
                                sx={{ bgcolor: "rgba(219, 218, 222, 1)" }}
                              />
                            </Grid>
                            <Grid item sm={5}>
                              <Skeleton
                                variant="text"
                                width="80%"
                                sx={{
                                  fontSize: "clamp(13px, 1.2vw, 15px)",
                                  height: "22px",
                                }}
                              />
                              <Skeleton
                                variant="text"
                                width="50%"
                                sx={{
                                  fontSize: "clamp(14px, 1.2vw, 16px)",
                                  height: "24px",
                                  marginTop: 1,
                                }}
                              />
                              <Skeleton
                                variant="text"
                                width="40%"
                                sx={{
                                  fontSize: "clamp(11px, 1.2vw, 13px)",
                                  height: "20px",
                                  marginTop: 1,
                                }}
                              />
                            </Grid>
                            <Grid item sm={12}>
                              <Box sx={{ width: "100%", marginTop: 3 }}>
                                <Skeleton
                                  variant="rectangular"
                                  width="100%"
                                  height="10px"
                                  sx={{ borderRadius: "4px" }}
                                />
                              </Box>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    </React.Fragment>
                  )}
                  {isXsOrSm && (
                    <Box className="dashboard-container-mobile">
                      <Grid
                        container
                        className="active-button-container"
                        sx={{ marginTop: "10px" }}
                      >
                        <Grid item xs={9}>
                          <Box>
                            <Skeleton variant="text" width="80%" height={40} />
                          </Box>
                        </Grid>
                        <Grid item xs={3}>
                          <Typography>
                            <Skeleton variant="text" width="50%" height={40} />
                          </Typography>
                        </Grid>
                      </Grid>
                      <Grid container sx={{ marginTop: 3 }}>
                        <Grid item xs={6}>
                          <Skeleton
                            variant="rectangular"
                            width="80%"
                            height={40}
                          />
                        </Grid>
                        <Grid item xs={6}>
                          <Skeleton
                            variant="rectangular"
                            width="80%"
                            height={40}
                          />
                        </Grid>
                        <Grid item xs={12} sx={{ marginTop: 2 }}>
                          <Skeleton
                            variant="rectangular"
                            width="100%"
                            height={10}
                          />
                        </Grid>
                      </Grid>
                      <Grid container sx={{ marginTop: 3 }}>
                        <Grid item xs={4}>
                          <Skeleton variant="text" />
                          <Skeleton variant="text" width="80%" />
                        </Grid>
                        <Grid item xs={4}>
                          <Skeleton variant="text" />
                          <Skeleton variant="text" width="80%" />
                        </Grid>
                        <Grid item xs={4}>
                          <Skeleton variant="text" />
                          <Skeleton variant="text" width="80%" />
                        </Grid>
                      </Grid>
                      <Grid container sx={{ marginTop: 3 }}>
                        <Grid item xs={4}>
                          <Skeleton variant="text" />
                          <Skeleton variant="text" width="80%" />
                        </Grid>
                        <Grid item xs={4}>
                          <Skeleton variant="text" />
                          <Skeleton variant="text" width="80%" />
                        </Grid>
                        <Grid item xs={4}>
                          <Skeleton variant="text" />
                          <Skeleton variant="text" width="80%" />
                        </Grid>
                      </Grid>
                      <Grid container sx={{ marginTop: 4 }}>
                        <Grid item xs={12}>
                          <Skeleton
                            variant="rectangular"
                            width="100%"
                            height={50}
                          />
                        </Grid>
                      </Grid>
                    </Box>
                  )}
                </>
              ) : (
                <>
                  {disbursementuserDetails?.map((item: any, index: any) => (
                    <React.Fragment key={index}>
                      {!isXsOrSm && (
                        <>
                          <Grid container sm>
                            <Grid item sm={7} sx={{ height: "22px" }}>
                              <Typography
                                className="loan-account-main-heading"
                                style={{ marginBottom: "5px" }}
                              >
                                Loan A/c {selectedloanAccountNumber}
                              </Typography>
                              <Typography className="loan-account-sub-heading">
                                {item?.description}
                              </Typography>
                            </Grid>
                            <Grid
                              item
                              sm={5}
                              sx={{
                                display: "flex",
                                justifyContent: "right",
                                alignItems: "right",
                              }}
                            >
                              <OutlinedSmallButton
                                iconPosition={"left"}
                                icon={<AddIcon />}
                                title={"Create New Request"}
                                click={createNewRequestBtn}
                                disabled={isMultipleReqRes}
                              />
                            </Grid>
                          </Grid>
                          <Grid container sm className="mt-20">
                            <Grid item sm={12}>
                              <Divider
                                sx={{
                                  border: isXsOrSm
                                    ? ""
                                    : "1px solid rgba(219, 218, 222, 1)",
                                  borderColor: isXsOrSm
                                    ? "rgba(0, 0, 0, 0.12)"
                                    : "",
                                  borderBottomWidth: isXsOrSm ? "thin" : "",
                                  width: "100%",
                                }}
                              />
                            </Grid>
                          </Grid>
                          <Grid container sm className="mt-20">
                            <Grid item xs={12} sm={7} md={7} lg={7}>
                              <Grid
                                container
                                spacing={2}
                                className="dashboard-container"
                              >
                                <Grid item xs={6} sm={4} md={4} lg={4}>
                                  <Typography className="insidePageLable">
                                    Name of the University
                                  </Typography>

                                  <Tooltip
                                    arrow
                                    enterTouchDelay={50}
                                    title={item?.nameOfTheUniversity}
                                    placement="bottom-end"
                                    className="insidePageValue"
                                    style={{ marginBottom: "10px" }}
                                    PopperProps={{
                                      style: {
                                        transformOrigin: "right center",
                                      },
                                    }}
                                    componentsProps={{
                                      tooltip: {
                                        sx: {
                                          bgcolor: "common.white",
                                          "& .MuiTooltip-arrow": {
                                            color: "common.white",
                                          },
                                          color: "#4B465C",
                                          fontSize: "14px",
                                          fontWeight: "400",
                                          lineHeight: "30px",
                                          fontFamily: "Jost",
                                          padding: "10px",
                                          width: "480px",
                                          cursor: "help",
                                          boxShadow:
                                            "-24px -12px 59px 0px #0000001A",
                                          border: "1px solid #E6E6E6",
                                        },
                                      },
                                    }}
                                  >
                                    <div>
                                      {item?.nameOfTheUniversity?.slice(0, 13)}
                                      {item?.nameOfTheUniversity?.length >
                                        13 && (
                                          <span className="insidePageValue">
                                            {" "}
                                            ...
                                          </span>
                                        )}
                                    </div>
                                  </Tooltip>
                                </Grid>
                                <Grid item xs={6} sm={4} md={4} lg={4}>
                                  <Typography className="insidePageLable">
                                    Last Disbursement Date
                                  </Typography>
                                  <Typography className="insidePageValue">
                                    {formatDate(item?.lastDisbursementDate)}
                                  </Typography>
                                </Grid>
                                <Grid item xs={6} sm={4} md={4} lg={4}>
                                  <Typography className="insidePageLable">
                                    Total Sanctioned Amount
                                  </Typography>
                                  <Typography
                                    variant="subtitle1"
                                    className="insidePageValue"
                                  >
                                    {formatIndianRupees(
                                      item?.totalSanctionedAmount
                                    )}
                                  </Typography>
                                </Grid>
                              </Grid>

                              <Grid
                                container
                                spacing={2}
                                className="dashboard-container"
                                sx={{
                                  marginTop: "-16px !important"
                                }}
                              >
                                <Grid item xs={6} sm={4} md={4} lg={4}>
                                  <Typography className="insidePageLable">
                                    Total undisbursed amount
                                  </Typography>
                                  <Typography
                                    variant="subtitle1"
                                    className="insidePageValue"
                                  >
                                    {formatIndianRupees(
                                      item?.loanUndisbursedAmount
                                    )}
                                  </Typography>
                                </Grid>

                                <Grid item xs={6} sm={4} md={4} lg={4}>
                                  <Typography className="insidePageLable">
                                    Loan Amount
                                  </Typography>
                                  <Typography
                                    variant="subtitle1"
                                    className="insidePageValue"
                                  >
                                    {formatIndianRupees(item?.loanAmount)}
                                  </Typography>
                                </Grid>
                              </Grid>
                            </Grid>

                            <Grid item xs={12} sm={5} md={5} lg={5}>
                              <div style={{ display: "flex" }}>
                                {!isXsOrSm && (
                                  <div className="line-container">
                                    <div className="line vertical"></div>

                                    <div className="line vertical"></div>
                                  </div>
                                )}
                                <Grid
                                  container
                                  sm
                                  className="muiLinearProgress"
                                >
                                  {/* Utilised Section */}
                                  <Grid
                                    item
                                    xs={6}
                                    sm={6}
                                    md={6}
                                    lg={6}
                                    className="right-border"
                                  >
                                    <Typography className="mainHeadingLable muiLinear-progress-p">
                                      <img
                                        src={UtilizedIcon}
                                        alt="Available"
                                        style={{
                                          height: "22px",
                                        }}
                                      />
                                      <span className="left-side-span">
                                        Disbursed Amount
                                      </span>
                                    </Typography>
                                    <Typography className="mainHeadingValue">
                                      {formatIndianRupees(item?.loanAmount)}
                                    </Typography>
                                    {/* Calculate and display the dynamic percentage */}
                                    <Typography className="mainHeadingPerValue">
                                      {handlePercentAmount(
                                        item?.loanAmount,
                                        item?.repayAmount,
                                        "disburse"
                                      )}
                                      % used
                                    </Typography>
                                  </Grid>
                                  {/* Available Section */}
                                  <Grid item xs={6} sm={6} md={6} lg={6}>
                                    <Typography className="mainHeadingLable text-align-right">
                                      <span className="right-side-span">
                                        Sanctioned Amount
                                      </span>
                                      <img
                                        src={AvailableIcon}
                                        alt="Available"
                                        style={{
                                          height: "22px",
                                        }}
                                      />
                                    </Typography>

                                    <div className="muiLinear-progress-div">
                                      <Typography className="mainHeadingValue text-align-right mainHeadingValueRight">
                                        {formatIndianRupees(item?.repayAmount)}
                                      </Typography>
                                      {/* Calculate and display the dynamic percentage */}
                                      <Typography className="mainHeadingPerValue text-align-right">
                                        {handlePercentAmount(
                                          item?.loanAmount,
                                          item?.repayAmount,
                                          "sanction"
                                        )}
                                        % left
                                      </Typography>
                                    </div>
                                  </Grid>

                                  <Grid item xs={12} sm={12} md={12} lg={12}>
                                    <Box sx={{ width: "100%", marginTop: 3 }}>
                                      <MultiColorProgressBar
                                        variant="determinate"
                                        value={parseInt(checkPercentage(item))} // Dynamic percentage
                                      />
                                    </Box>
                                  </Grid>
                                </Grid>
                              </div>
                            </Grid>
                          </Grid>
                        </>
                      )}
                      {isXsOrSm && (
                        <>
                          <Grid container className="active-button-container">
                            <Grid item xs={9} sm={9} md={7} lg={7}>
                              <Box sx={{ float: "left" }}>
                                <AccountSelectorDropDown
                                  labelText="Loan account number"
                                  buttonText=" N/A"
                                  isActive={""}
                                  backgroundColor="transparent"
                                  borderWidth="0px"
                                  marginTop="0px"
                                />
                              </Box>
                            </Grid>
                            <Grid item xs={3} sm={3} md={5} lg={5}>
                              {/* <Typography
                                className="active-button"
                                style={{
                                  color:
                                    item?.status === "A"
                                      ? "#28C76F"
                                      : "#EA5455",
                                  backgroundColor:
                                    item?.status === "A"
                                      ? "#28C76F29"
                                      : "#EA545529",
                                }}
                              >
                                {item?.status === "A" ? "Active" : "Closed"}
                              </Typography> */}
                            </Grid>
                            <Divider
                              sx={{
                                border: isXsOrSm
                                  ? ""
                                  : "1px solid rgba(219, 218, 222, 1)",
                                borderColor: isXsOrSm
                                  ? "rgba(0, 0, 0, 0.12)"
                                  : "",
                                borderBottomWidth: isXsOrSm ? "thin" : "",
                                width: "100%",
                                marginTop: "6px",
                              }}
                            />
                          </Grid>
                          <Grid container sm className="mt-20">
                            <Grid
                              item
                              xs={12}
                              sm={5}
                              md={5}
                              lg={5}
                              className="mb-20"
                            >
                              <div style={{ display: "flex" }}>
                                {!isXsOrSm && (
                                  <div className="line-container">
                                    <div className="line vertical"></div>
                                    <div className="line vertical"></div>
                                  </div>
                                )}
                                <Grid
                                  container
                                  sm
                                  className="muiLinearProgress"
                                >
                                  {/* Utilised Section */}
                                  <Grid
                                    item
                                    xs={6}
                                    sm={6}
                                    md={6}
                                    lg={6}
                                    className="right-border"
                                  >
                                    <Typography className="mainHeadingLable muiLinear-progress-p">
                                      <img
                                        src={UtilizedIcon}
                                        alt="Available"
                                        style={{
                                          height: "22px",
                                        }}
                                      />
                                      <span className="left-side-span">
                                        Disbursed Amount
                                      </span>
                                    </Typography>
                                    <Typography className="mainHeadingValueMobile">
                                      {formatIndianRupees(item?.loanAmount)}
                                    </Typography>
                                    {/* Calculate and display the dynamic percentage */}
                                    <Typography className="mainHeadingPerValueMobile">
                                      {handlePercentAmount(
                                        item?.loanAmount,
                                        item?.repayAmount,
                                        "disburse"
                                      )}
                                      % used
                                    </Typography>
                                  </Grid>
                                  <Grid item xs={6} sm={6} md={6} lg={6}>
                                    <Typography className="mainHeadingLable  text-align-right">
                                      <span className="right-side-span">
                                        Sanctioned Amount
                                      </span>
                                      <img
                                        src={AvailableIcon}
                                        alt="Available"
                                        style={{
                                          height: "22px",
                                        }}
                                      />
                                    </Typography>
                                    <Typography className="mainHeadingValueMobile text-align-right mainHeadingValueMobileRight">
                                      {formatIndianRupees(item?.repayAmount)}
                                    </Typography>
                                    {/* Calculate and display the dynamic percentage */}
                                    <Typography className="mainHeadingPerValueMobile text-align-right">
                                      {handlePercentAmount(
                                        item?.loanAmount,
                                        item?.repayAmount,
                                        "sanction"
                                      )}
                                      % left
                                    </Typography>
                                  </Grid>

                                  <Grid item xs={12} sm={12} md={12} lg={12}>
                                    <Box sx={{ width: "100%", marginTop: 1 }}>
                                      <MultiColorProgressBarMobile
                                        variant="determinate"
                                        value={parseInt(checkPercentage(item))} // Dynamic percentage
                                      />
                                    </Box>
                                  </Grid>
                                </Grid>
                              </div>
                            </Grid>
                            <Grid
                              item
                              xs={12}
                              sm={7}
                              md={7}
                              lg={7}
                              className="dashboard-container-mobile"
                            >
                              <Grid container spacing={spacing}>
                                <Grid item xs={4} sm={4} md={4} lg={4}>
                                  <Typography className="insidePageLableMobile">
                                    Name of the University
                                  </Typography>

                                  <Tooltip
                                    arrow
                                    title={item?.nameOfTheUniversity}
                                    placement="bottom-end"
                                    className="insidePageValueMobile"
                                    style={{ marginBottom: "10px" }}
                                    enterTouchDelay={50}
                                    PopperProps={{
                                      style: {
                                        transformOrigin: "right center",
                                      },
                                    }}
                                    componentsProps={{
                                      tooltip: {
                                        sx: {
                                          bgcolor: "common.white",
                                          "& .MuiTooltip-arrow": {
                                            color: "common.white",
                                          },
                                          color: "#4B465C",
                                          fontSize: isXsOrSm ? "10px" : "14px",
                                          fontWeight: "400",
                                          lineHeight: isXsOrSm
                                            ? "20px"
                                            : "30px",
                                          fontFamily: "Jost",
                                          padding: "10px",
                                          width: "480px",
                                          cursor: "help",
                                          boxShadow:
                                            "-24px -12px 59px 0px #0000001A",
                                          border: "1px solid #E6E6E6",
                                        },
                                      },
                                    }}
                                  >
                                    <div>
                                      {item?.nameOfTheUniversity?.slice(0, 13)}
                                      {item?.nameOfTheUniversity?.length >
                                        13 && (
                                          <span className="insidePageValue">
                                            {" "}
                                            ...
                                          </span>
                                        )}
                                    </div>
                                  </Tooltip>
                                </Grid>
                                <Grid item xs={4} sm={4} md={4} lg={4}>
                                  <Typography className="insidePageLableMobile">
                                    Last Disbursement Date
                                  </Typography>
                                  <Typography
                                    variant="subtitle1"
                                    className="insidePageValueMobile"
                                  >
                                    {formatDate(item?.lastDisbursementDate)}
                                  </Typography>
                                </Grid>
                                <Grid item xs={4} sm={4} md={4} lg={4}>
                                  <Typography className="insidePageLableMobile">
                                    Total Sanctioned Amount
                                  </Typography>
                                  <Typography
                                    variant="subtitle1"
                                    className="insidePageValueMobile"
                                  >
                                    {formatIndianRupees(
                                      item?.totalSanctionedAmount
                                    )}
                                  </Typography>
                                </Grid>
                              </Grid>

                              <Grid container spacing={spacing} mt={1}>
                                <Grid item xs={4} sm={4} md={4} lg={4}>
                                  <Typography className="insidePageLableMobile">
                                    Total undisbursed amount
                                  </Typography>
                                  <Typography
                                    variant="subtitle1"
                                    className="insidePageValueMobile"
                                  >
                                    {formatIndianRupees(
                                      item?.loanUndisbursedAmount
                                    )}
                                  </Typography>
                                </Grid>
                                <Grid item xs={4} sm={4} md={4} lg={4}>
                                  <Typography className="insidePageLableMobile">
                                    Loan Amount
                                  </Typography>
                                  <Typography
                                    variant="subtitle1"
                                    className="insidePageValueMobile"
                                  >
                                    {formatIndianRupees(item?.loanAmount)}
                                  </Typography>
                                </Grid>
                                <Grid item xs={4} sm={4} md={4} lg={4}></Grid>
                              </Grid>
                            </Grid>
                            <Grid container sm className="mt-20"></Grid>
                          </Grid>
                        </>
                      )}
                    </React.Fragment>
                  ))}
                </>
              )}
            </Box>

            {isLoading ? (
              <>
                <AccordionTransition title={"Loading..."}>
                  <Grid container marginTop={2}>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <Typography
                        sx={{
                          color: "rgba(75, 70, 92, 1)",
                          fontSize: "clamp(11px, 1.2vw, 13px)",
                          fontWeight: "600",
                          lineHeight: "21px",
                        }}
                      >
                        <Skeleton width="60%" />
                      </Typography>
                    </Grid>
                  </Grid>
                </AccordionTransition>
              </>
            ) : (
              <>
                <Box
                  sx={{
                    borderRadius: "4px",
                    boxShadow: "none",
                    backgroundColor: "#f8f9f9",
                    paddingLeft: "4px",
                    paddingRight: "4px",
                  }}
                >
                  {isXsOrSm && (
                    <OutlinedSmallButton
                      iconPosition={"left"}
                      icon={<AddIcon />}
                      title={"Create New Request"}
                      click={createNewRequestBtn}
                      width={"100%"}
                      disabled={isMultipleReqRes}
                    />
                  )}
                  <AccordionTransition title={"Details"}>
                    <div
                      className="loan-details"
                      style={{ paddingBottom: "10px"}}
                    >
                      <Grid container marginTop={2}>
                        <Grid item xs={12} sm={12} md={12} lg={12}>
                          <Typography className="accordion-label">
                            Loan Details
                          </Typography>
                        </Grid>
                      </Grid>

                      <Grid container className="dashboard-container">
                        <Grid item xs={6} sm={3} md={3} lg={3}>
                          <Typography className="insidePageLable">
                            Total Interest Outstanding
                          </Typography>
                          <Typography className="insidePageValue">
                            {formatIndianRupees(
                              disbursementuserDetails?.[0]?.loanDetails
                                ?.totalPrincipalAmountPaid
                            )}
                          </Typography>
                        </Grid>

                        <Grid item xs={6} sm={3} md={3} lg={3}>
                          {isXsOrSm ? (
                            <div style={{ 
                            display: "flex",
                            alignItems: "center",
                            verticalAlign: "middle",
                           }}>
                            <Typography className="insidePageLable" sx={{marginRight: "0px", }}>
                                Total Principal Outstanding
                            </Typography>
                            <Tooltip
                              title="Principal Outstanding Amount After Moratorium End (If Applicable)"
                              enterTouchDelay={50}>
                              <img
                                src={InfoIcon}
                                alt="Info"
                                className="imgicon"
                                style={{ marginLeft: 2, cursor: "pointer", verticalAlign: "middle" }}
                              />
                            </Tooltip>
                          </div>

                          ) : (
                            <Typography className="insidePageLable" sx={{marginRight: "0px"}}>
                            Total Principal Outstanding
                            <Tooltip
                              title="Principal Outstanding Amount After Moratorium End (If Applicable)"
                              enterTouchDelay={50}
                            >
                              <img
                                src={InfoIcon}
                                alt="Info"
                                className="imgicon"
                                style={{ marginLeft: 6, cursor: "pointer", verticalAlign: "middle" }}
                              />
                            </Tooltip>
                          </Typography>
                          )}
                          
                          <Typography className="insidePageValue">
                            {formatIndianRupees(
                              disbursementuserDetails?.[0]?.loanDetails
                                ?.totalPrincipalOutstanding
                            )}
                          </Typography>
                        </Grid>

                        <Grid item xs={6} sm={3} md={3} lg={3}>
                          <Typography className="insidePageLable">
                            Loan Start Date
                          </Typography>
                          <Typography className="insidePageValue">
                            {formatDate(
                              disbursementuserDetails?.[0]?.loanDetails
                                ?.loanStartDate
                            )}
                          </Typography>
                        </Grid>

                        <Grid item xs={6} sm={3} md={3} lg={3}>
                          <Typography className="insidePageLable">
                            Next Repay Amount
                          </Typography>
                          <Typography className="insidePageValue">
                            {formatIndianRupees(
                              disbursementuserDetails?.[0]?.loanDetails
                                ?.nextRepaymentAmount
                            )}
                          </Typography>
                        </Grid>
                      </Grid>

                      <Grid container className="dashboard-container">
                        <Grid item xs={6} sm={3} md={3} lg={3}>
                          <Typography className="insidePageLable">
                            Total Loan Outstanding
                          </Typography>
                          <Typography className="insidePageValue">
                            {formatIndianRupees(
                              disbursementuserDetails?.[0]?.loanDetails
                                ?.totalLoanOutstanding
                            )}
                          </Typography>
                        </Grid>

                        <Grid item xs={6} sm={3} md={3} lg={3}>
                          <Typography className="insidePageLable">
                            Loan End Date
                          </Typography>
                          <Typography className="insidePageValue">
                            {formatDate(
                              disbursementuserDetails?.[0]?.loanDetails
                                ?.loanEndDate
                            )}
                          </Typography>
                        </Grid>

                        <Grid item xs={6} sm={3} md={3} lg={3}>
                          <Typography className="insidePageLable">
                            Remaining Tenure(Months)
                          </Typography>
                          <Typography className="insidePageValue">
                            {
                              disbursementuserDetails?.[0]?.loanDetails
                                ?.remainingTenure
                            }
                          </Typography>
                        </Grid>

                        <Grid item xs={6} sm={3} md={3} lg={3}>
                          <Typography className="insidePageLable">
                            Next Repay Date
                          </Typography>
                          <Typography className="insidePageValue">
                            {formatDate(
                              disbursementuserDetails?.[0]?.loanDetails
                                ?.nextRepaymentDate
                            )}
                          </Typography>
                        </Grid>
                      </Grid>
                    </div>
                  </AccordionTransition>
                </Box>
              </>
            )}
          </Card>
        </Grid>
      </Grid>
      <Grid container marginTop={2}>
        <Grid container>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Grid container alignItems="center" justifyContent="space-between">
              <Grid item>
                <Typography className="loan-account-main-heading">
                  Fund Release Request History
                </Typography>
              </Grid>
              {!isXsOrSm && (
                <Grid item style={{ display: "inline-flex" }} gap={2}>
                  <span
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      fontFamily: "Jost",
                      fontSize: "clamp(9px, 1.2vw, 11px)",
                      fontWeight: "500",
                      lineHeight: "19.36px",
                      textAlign: "left",
                      color: "#00B3B5",
                      width: "fit-content",
                      height: "27px",
                      padding: "14px 12px",
                      borderRadius: "4px",
                      border: "0.5px solid #00B3B5",
                      cursor: "pointer",
                    }}
                    onClick={handleFilterButtonClick}
                  >
                    <img
                      src={filterIcon}
                      alt="Filter Icon"
                      style={{ width: "13px", color: "#00B3B5" }}
                    />{" "}
                    Filter
                  </span>
                </Grid>
              )}
            </Grid>
            {!isXsOrSm && (
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
                style={{ marginTop: "20px" }}
              >
                <Tables
                  columns={columns}
                  rows={rows}
                  page={page}
                  isLoading={IsLoadingRequest}
                  rowsPerPage={rowsPerPage}
                  totalRecords={totalRecords}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  onActionClick={handleActionClick}
                />
              </Grid>
            )}
            {isXsOrSm && (
              <CardItemList testData={rows} onActionClick={handleActionClick} />
            )}
          </Grid>
        </Grid>
        {/* -------------------------------Filter Modal Popup--  ----------------------------------------- */}
        <Toast
          open={toastOpen}
          message={message}
          severity={severity}
          onClose={handleToastClose}
        />
        <ModalPopup
          isOpen={isModalOpen}
          onClose={handleCloseModal}
          title="Filter"
          onNavigate={() => { }}
          style={{
            position: "fixed",
            top: 0,
            right: 0,
            padding: "16px 16px 63px 16px",
            margin: "0px",
            borderRadius: "8px 0px 0px 8px",
            height: "100vh",
            width: "340px",
            zIndex: 9999,
          }}
        >
          <SelectOptions
            options={filterOptionsDisbursement}
            label="Select Option"
            isMandatory={false}
            value={selectedOptionFilterValue}
            onChange={(value: string | number) => {
              setSelectedOptionFilterValue(value);
            }}
          />

          <BasicDatePicker
            label="From Date"
            width="100%"
            onChange={handleFromDateChange}
            value={fromDate ? dayjs(fromDate) : null}
          />
          <BasicDatePicker
            label="To date"
            width="100%"
            onChange={handleToDateChange}
            value={toDate ? dayjs(toDate) : null}
          />
          <Box display="flex" justifyContent="space-between" gap={2} mt={2}>
            <SecondaryButtonText
              sx={{
                height: "39px",
              }}
              variant="outlined"
              fullWidth
              onClick={clearData}   // <-- your clear handler
            >
              Clear
            </SecondaryButtonText>

            <PrimaryButton
              fullWidth
              type="submit"
              onClick={filterData}
            >
              Apply
            </PrimaryButton>
          </Box>
        </ModalPopup>
        {/* -------------------------------Otp Modal Popup------------------------------------------- */}
      </Grid>
      {/* <LoaderBackdrop open={isLoading} /> */}
    </Grid>
  );
};

export default RequestForDisbursement;
